// extracted by mini-css-extract-plugin
export default {"search":"Search_search__lwTrv","img_search":"Search_img_search__62zXO"};